import { render, staticRenderFns } from "./FeaturedGifts.vue?vue&type=template&id=5b8ca45a&scoped=true"
import script from "./FeaturedGifts.vue?vue&type=script&lang=js"
export * from "./FeaturedGifts.vue?vue&type=script&lang=js"
import style0 from "./FeaturedGifts.vue?vue&type=style&index=0&id=5b8ca45a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8ca45a",
  null
  
)

export default component.exports